import axiosCall from "./axiosCall";
import axios from "axios";

import {
  SMARTYSTREET_KEY,
  SKIP_SMARTY_STREET_VERIFICATION,
} from "../constant/Constants";
import { resetSessionTiming } from "./sessionManagement";


export const smartyStreetService = async ({
  address,
  callbackVerifiedAddress,
  name,
  i,
}) => {
  resetSessionTiming()
  // let responseDetails = {
  //         callback: callbackVerifiedAddress,
  //         has_i: false,
  //         i: 0,
  //         providedAddress: {
  //           street: "1871 BOYERS RD",
  //           street2: "",
  //           city: "ROCKINGHAM",
  //           zipcode: "22801",
  //           state: "VA",
  //           record_type : "Valid",
  //           isValidateAddress : "NoMatch",
  //              IsValid : false,
  //              NoMatch : false,
  //              PartialMatch : true,
  //              ExactMatch : false
  //         },
  //         suggestedAddress: {
  //             street: "1871 BOYERS kkkk oooD",
  //             street2: "",
  //             city: "ROCKINGHAM",
  //             zipcode: "22805",
  //             state: "VA",
  //             record_type : "Valid",
  //             isValidateAddress : "ExactMatch",
  //                IsValid : true,
  //                NoMatch : false,
  //                PartialMatch : false,
  //                ExactMatch : true,
  //                SecInfoNotMatch : false,
  //         },
  //         response:{
  //           street: address.addressLine1 != undefined ? address.addressLine1 : "",
  //           street2: address.addressLine2 != undefined ? address.addressLine2 : "",
  //           city: address.city != undefined ? address.city : "",
  //           zipcode: address.zipCode != undefined ? address.zipCode : "",
  //           state: address.state != undefined ? address.state : "",
  //           record_type : "",
  //           isValidateAddress : 'ExactMatch',
  //               IsValid : true,
  //                NoMatch : false,
  //                PartialMatch : false,
  //                ExactMatch : false,
  //                SecInfoNotMatch : false,
  //         },
  //         ss_msg: 'We could not verify the address information provided. Please consider the following suggestion:',
  //         partial: true,
  //         ss_toggle: true,
  //         record_type:'Valid',
  //         allowSSRequest: true,
  // };
  let responseDetails = {};
  let ss_toggle;
  let ss_msg = "";
  let callback = () => {
    return false;
  };
  let has_i = false;
  let allowSSRequest = true;
  let providedAddress = {};
  let suggestedAddress = {};
  let partial = false;
  let lookup = {};
  let response = {};
  let prvresponse = {};
  if (
    address.addressLine1 != "" ||
    address.addressLine2 != "" ||
    address.city != "" ||
    address.state != "" ||
    address.zipCode != ""
  ) {
    ss_toggle = address.addressLine1 == "" ? false : false;
    ss_msg = "";
    let authId = SMARTYSTREET_KEY;
    let authToken = "Y1Hat9JQV2XLX1TaWepc";

    prvresponse.street =
      address.addressLine1 != undefined ? address.addressLine1 : "";
    prvresponse.street2 =
      address.addressLine2 != undefined ? address.addressLine2 : "";
    prvresponse.city = address.city != undefined ? address.city : "";
    prvresponse.state = address.state != undefined ? address.state : "";
    prvresponse.zipcode = address.zipCode != undefined ? address.zipCode : "";
    prvresponse.record_type = "Valid";
    // return responseDetails

    lookup.street =
      address.addressLine1 != undefined
        ? encodeURIComponent(address.addressLine1)
        : "";
    lookup.street2 =
      address.addressLine2 != undefined
        ? encodeURIComponent(address.addressLine2)
        : "";
    lookup.city =
      address.city != undefined ? encodeURIComponent(address.city) : "";
    lookup.state =
      address.state != undefined ? encodeURIComponent(address.state) : "";
    lookup.zipCode =
      address.zipCode != undefined ? encodeURIComponent(address.zipCode) : "";
    lookup.maxCandidates = 10;
    //lookup.match = "invalid";
    address.record_type = "Valid";

    if (allowSSRequest) {
      if (typeof address.Skip == "undefined") {
        allowSSRequest = false;
        setTimeout(() => {
          allowSSRequest = true;
        }, 5000);
      }
      let queryString =
        "key=" +
        authId +
        "&street=" +
        lookup.street +
        "&street2=" +
        lookup.street2 +
        "&city=" +
        lookup.city +
        "&state=" +
        lookup.state +
        "&zipcode=" +
        lookup.zipCode +
        "&candidates=" +
        lookup.maxCandidates;
      let resAPI = await axios.get(`https://us-street.api.smartystreets.com/street-address?${queryString}`);
      let res =resAPI.data
      if (res.length != 0) {
        if (
          res[0].analysis.dpv_match_code == "Y" &&
          res[0].analysis.dpv_footnotes == "AABB" &&
          (res[0].analysis.footnotes == undefined ||
            res[0].analysis.footnotes == "AABB")
        ) {
          let addressLine1 = '';
          if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_predirection != "undefined" && typeof res[0]?.components?.street_postdirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_predirection} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix} ${res[0]?.components?.street_postdirection}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_predirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_predirection} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_postdirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix} ${res[0]?.components?.street_postdirection}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else {
            addressLine1 = `${typeof res[0]?.components?.primary_number != "undefined" ? res[0]?.components?.primary_number : ''} ${typeof res[0]?.components?.street_name != "undefined" ? res[0]?.components?.street_name : ''} ${typeof res[0]?.components?.street_suffix != "undefined" ? res[0]?.components?.street_suffix : ''}`;
          }
          const addressLine1Length = (res[0].delivery_line_1 != undefined && res[0].delivery_line_1?.length > 35) ? true : false;
          const addressLine2 = `${typeof res[0]?.components?.secondary_designator != "undefined" ? res[0]?.components?.secondary_designator : ''} ${typeof res[0]?.components?.secondary_number != "undefined" ? res[0]?.components?.secondary_number : ''}`;

          if (typeof res[0]?.components?.secondary_designator != "undefined" && typeof res[0]?.components?.secondary_number != "undefined" && addressLine1Length) {
            response.street = addressLine1
            response.street2 = addressLine2
            // prvresponse.street = addressLine1
            // prvresponse.street2 = addressLine2
          } else {
            response.street = res[0].delivery_line_1 != undefined ? res[0].delivery_line_1 : ''
            response.street2 = res[0].delivery_line_2 != undefined ? res[0].delivery_line_2 : ''
          }
                                
          // response.street =
          //   address.addressLine1 != undefined ? address.addressLine1 : "";
          // response.street2 =
          //   address.addressLine2 != undefined ? address.addressLine2 : "";
          response.city = address.city != undefined ? address.city : "";
          response.state = address.state != undefined ? address.state : "";
          response.zipcode =
            address.zipCode != undefined ? address.zipCode : "";
          response.record_type = "Valid";
          response.isValidateAddress = "ExactMatch";
          response.IsValid = true;
          response.NoMatch = false;
          response.PartialMatch = false;
          response.ExactMatch = true;
          response.SecInfoNotMatch = false;
          // if (typeof i != "undefined") {
          //   callbackVerifiedAddress(response, i);
          // } else {
            callbackVerifiedAddress(response,name);
          // }
        } else if (
          res[0].analysis.dpv_match_code == "S" ||
          res[0].analysis.dpv_match_code == "D"
        ) {
          let addressLine1 = '';
          if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_predirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_predirection} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else {
            addressLine1 = `${typeof res[0]?.components?.primary_number != "undefined" ? res[0]?.components?.primary_number : ''} ${typeof res[0]?.components?.street_name != "undefined" ? res[0]?.components?.street_name : ''} ${typeof res[0]?.components?.street_suffix != "undefined" ? res[0]?.components?.street_suffix : ''}`;
          }
          const addressLine1Length = (res[0].delivery_line_1 != undefined && res[0].delivery_line_1?.length > 35) ? false : false;
          const addressLine2 = `${typeof res[0]?.components?.secondary_designator != "undefined" ? res[0]?.components?.secondary_designator : ''} ${typeof res[0]?.components?.secondary_number != "undefined" ? res[0]?.components?.secondary_number : ''}`;

          ss_msg =
            "We could not verify the information provided. Please confirm the address entered is accurate.";
          partial = false;
          if (typeof res[0]?.components?.secondary_designator != "undefined" && typeof res[0]?.components?.secondary_number != "undefined" && addressLine1Length) {
            response.street = addressLine1
            response.street2 = addressLine2
            prvresponse.street = addressLine1
            prvresponse.street2 = addressLine2
          } else {
            response.street = res[0].delivery_line_1 != undefined ? res[0].delivery_line_1 : ''
            response.street2 = res[0].delivery_line_2 != undefined ? res[0].delivery_line_2 : ''
          }
          // response.street =
          //   res[0].delivery_line_1 != undefined ? res[0].delivery_line_1 : "";
          // response.street2 =
          //   res[0].delivery_line_2 != undefined ? res[0].delivery_line_2 : "";
          response.record_type = "Valid";
          response.isValidateAddress = "ExactMatch";
          prvresponse.IsValid = true;
          prvresponse.NoMatch = false;
          prvresponse.PartialMatch = false;
          prvresponse.ExactMatch = false;
          prvresponse.SecInfoNotMatch = true;
          if (res[0].components != undefined) {
            response.city =
              res[0].components.default_city_name != undefined
                ? res[0].components.default_city_name
                : res[0].components.city_name != undefined
                ? res[0].components.city_name
                : "";
            response.state =
              res[0].components.state_abbreviation != undefined
                ? res[0].components.state_abbreviation
                : "";
            response.zipcode =
              res[0].components.zipcode != undefined
                ? res[0].components.zipcode
                : "";
          } else {
            response.city = "";
            response.state = "";
            response.zipcode = "";
          }
          providedAddress = prvresponse;
          ss_toggle = address.addressLine1 != "" ? true : false;
        } else if (
          res[0].analysis.dpv_match_code == "Y" &&
          res[0].analysis.footnotes != undefined &&
          res[0].analysis.footnotes != "AABB"
        ) {
          let addressLine1 = '';
          if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_predirection != "undefined" && typeof res[0]?.components?.street_postdirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_predirection} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix} ${res[0]?.components?.street_postdirection}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_predirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_predirection} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_postdirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix} ${res[0]?.components?.street_postdirection}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else {
            addressLine1 = `${typeof res[0]?.components?.primary_number != "undefined" ? res[0]?.components?.primary_number : ''} ${typeof res[0]?.components?.street_name != "undefined" ? res[0]?.components?.street_name : ''} ${typeof res[0]?.components?.street_suffix != "undefined" ? res[0]?.components?.street_suffix : ''}`;
          }
          const addressLine1Length = (res[0].delivery_line_1 != undefined && res[0].delivery_line_1?.length > 35) ? true : false;
          const addressLine2 = `${typeof res[0]?.components?.secondary_designator != "undefined" ? res[0]?.components?.secondary_designator : ''} ${typeof res[0]?.components?.secondary_number != "undefined" ? res[0]?.components?.secondary_number : ''}`;

          ss_msg =
            "We could not verify the address information provided. Please consider the following suggestion:";
          partial = true;
          // response.street =
          //   res[0].delivery_line_1 != undefined ? res[0].delivery_line_1 : "";
          // response.street2 =
          //   res[0].delivery_line_2 != undefined ? res[0].delivery_line_2 : "";
          if (typeof res[0]?.components?.secondary_designator != "undefined" && typeof res[0]?.components?.secondary_number != "undefined" && addressLine1Length) {
            response.street = addressLine1
            response.street2 = addressLine2
            // prvresponse.street = addressLine1
            // prvresponse.street2 = addressLine2
          } else {
            response.street = res[0].delivery_line_1 != undefined ? res[0].delivery_line_1 : ''
            response.street2 = res[0].delivery_line_2 != undefined ? res[0].delivery_line_2 : ''
          }
          response.record_type = "Valid";
          response.isValidateAddress = "ExactMatch";
          response.IsValid = true;
          response.NoMatch = false;
          response.PartialMatch = false;
          response.ExactMatch = false;
          response.SecInfoNotMatch = false;
          prvresponse.isValidateAddress = "NoMatch";
          prvresponse.IsValid = false;
          prvresponse.NoMatch = false;
          prvresponse.PartialMatch = true;
          prvresponse.ExactMatch = false;
          prvresponse.SecInfoNotMatch = false;
          if (res[0].components != undefined) {
            response.city =
              res[0].components.default_city_name != undefined
                ? res[0].components.default_city_name
                : res[0].components.city_name != undefined
                ? res[0].components.city_name
                : "";
            response.state =
              res[0].components.state_abbreviation != undefined
                ? res[0].components.state_abbreviation
                : "";
            response.zipcode =
              res[0].components.zipcode != undefined
                ? res[0].components.zipcode
                : "";
          } else {
            response.city = "";
            response.state = "";
            response.zipcode = "";
          }
          providedAddress = prvresponse;
          suggestedAddress = response;
          ss_toggle = address.addressLine1 != "" ? true : false;
        } else {
          let addressLine1 = '';
          if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined" && typeof res[0]?.components?.street_predirection != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_predirection} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else if (typeof res[0]?.components?.primary_number != "undefined" && typeof res[0]?.components?.street_name != "undefined" && typeof res[0]?.components?.street_suffix != "undefined") {
            addressLine1 = `${res[0]?.components?.primary_number} ${res[0]?.components?.street_name} ${res[0]?.components?.street_suffix}`
          } else {
            addressLine1 = `${typeof res[0]?.components?.primary_number != "undefined" ? res[0]?.components?.primary_number : ''} ${typeof res[0]?.components?.street_name != "undefined" ? res[0]?.components?.street_name : ''} ${typeof res[0]?.components?.street_suffix != "undefined" ? res[0]?.components?.street_suffix : ''}`;
          }
          const addressLine1Length = (res[0].delivery_line_1 != undefined && res[0].delivery_line_1?.length > 35) ? false : false;
          const addressLine2 = `${typeof res[0]?.components?.secondary_designator != "undefined" ? res[0]?.components?.secondary_designator : ''} ${typeof res[0]?.components?.secondary_number != "undefined" ? res[0]?.components?.secondary_number : ''}`;

          ss_msg =
            "We could not verify the information provided. Please confirm the address entered is accurate.";
          // response.street =
          //   address.addressLine1 != undefined ? address.addressLine1 : "";
          // response.street2 =
          //   address.addressLine2 != undefined ? address.addressLine2 : "";
          if (typeof res[0]?.components?.secondary_designator != "undefined" && typeof res[0]?.components?.secondary_number != "undefined" && addressLine1Length) {
            response.street = addressLine1
            response.street2 = addressLine2
            prvresponse.street = addressLine1
            prvresponse.street2 = addressLine2
          } else {
            response.street = res[0].delivery_line_1 != undefined ? res[0].delivery_line_1 : ''
            response.street2 = res[0].delivery_line_2 != undefined ? res[0].delivery_line_2 : ''
          }
          response.city = address.city != undefined ? address.city : "";
          response.state = address.state != undefined ? address.state : "";
          response.zipcode =
            address.zipCode != undefined ? address.zipCode : "";
          response.record_type = "";
          prvresponse.isValidateAddress = "NoMatch";
          prvresponse.IsValid = false;
          prvresponse.NoMatch = true;
          prvresponse.PartialMatch = false;
          prvresponse.ExactMatch = false;
          prvresponse.SecInfoNotMatch = false;
          providedAddress = prvresponse;
          ss_toggle = address.addressLine1 != "" ? true : false;
        }
      } else {
        response.street =
          address.addressLine1 != undefined ? address.addressLine1 : "";
        response.street2 =
          address.addressLine2 != undefined ? address.addressLine2 : "";
        response.city = address.city != undefined ? address.city : "";
        response.state = address.state != undefined ? address.state : "";
        response.zipcode = address.zipCode != undefined ? address.zipCode : "";
        response.record_type = "";
        prvresponse.IsValid = false;
        prvresponse.NoMatch = true;
        prvresponse.PartialMatch = false;
        prvresponse.ExactMatch = false;
        prvresponse.SecInfoNotMatch = false;
        prvresponse.isValidateAddress = "NoMatch";
        providedAddress = prvresponse;
        // if (typeof i != "undefined") {
        //   callbackVerifiedAddress(response, i);
        // } else {
          callbackVerifiedAddress(response,name);
        // }
      }

      if (typeof i != "undefined") {
        callback = callbackVerifiedAddress;
        has_i = true;
        i = i;
      } else {
        callback = callbackVerifiedAddress;
        has_i = false;
        i = 0;
      }
      responseDetails = {
        callback: callback,
        has_i: has_i,
        i: i,
        providedAddress: providedAddress,
        suggestedAddress: suggestedAddress,
        ss_msg: ss_msg,
        partial: partial,
        ss_toggle: ss_toggle,
        allowSSRequest: allowSSRequest,
        name,
      };
     // return responseDetails;
    }
    return responseDetails;
  } else {
    return false;
  }
};
